/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReportResultLogEntryRepresentation } from './ReportResultLogEntryRepresentation';
import {
    ReportResultLogEntryRepresentationFromJSON,
    ReportResultLogEntryRepresentationFromJSONTyped,
    ReportResultLogEntryRepresentationToJSON,
    ReportResultLogEntryRepresentationToJSONTyped,
} from './ReportResultLogEntryRepresentation';

/**
 * 
 * @export
 * @interface ReportResultRequest
 */
export interface ReportResultRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportResultRequest
     */
    jobId: number;
    /**
     * 
     * @type {string}
     * @memberof ReportResultRequest
     */
    documentKey: string;
    /**
     * The version for which the content of document is generated
     * @type {number}
     * @memberof ReportResultRequest
     */
    version: number;
    /**
     * 
     * @type {Array<ReportResultLogEntryRepresentation>}
     * @memberof ReportResultRequest
     */
    logs: Array<ReportResultLogEntryRepresentation>;
}

/**
 * Check if a given object implements the ReportResultRequest interface.
 */
export function instanceOfReportResultRequest(value: object): value is ReportResultRequest {
    if (!('jobId' in value) || value['jobId'] === undefined) return false;
    if (!('documentKey' in value) || value['documentKey'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('logs' in value) || value['logs'] === undefined) return false;
    return true;
}

export function ReportResultRequestFromJSON(json: any): ReportResultRequest {
    return ReportResultRequestFromJSONTyped(json, false);
}

export function ReportResultRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportResultRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'jobId': json['jobId'],
        'documentKey': json['documentKey'],
        'version': json['version'],
        'logs': ((json['logs'] as Array<any>).map(ReportResultLogEntryRepresentationFromJSON)),
    };
}

export function ReportResultRequestToJSON(json: any): ReportResultRequest {
    return ReportResultRequestToJSONTyped(json, false);
}

export function ReportResultRequestToJSONTyped(value?: ReportResultRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'jobId': value['jobId'],
        'documentKey': value['documentKey'],
        'version': value['version'],
        'logs': ((value['logs'] as Array<any>).map(ReportResultLogEntryRepresentationToJSON)),
    };
}

